import { selectForgetPasswordStep } from '../../store/forgetPassword/selectors';
import { useDispatch, useSelector } from '../../store/store';
import ResetPassword from './containers/ResetPassword';
import Entrance from '../../layouts/Entrance';
import Username from './containers/Username';
import Approval from './containers/Approval';
import Verify from './containers/Verify';
import { useEffect } from 'react';
import {
    setNewPassword,
    setForgetPasswordStep,
    setForgetPasswordUsername,
} from '../../store/forgetPassword/slice';

const steps = {
    Username: <Username />,
    verify: <Verify />,
    ResetPassword: <ResetPassword />,
    Approval: <Approval />,
};

function ForgetPassword() {
    const step = useSelector(selectForgetPasswordStep);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setForgetPasswordStep('Username'));
        dispatch(setForgetPasswordUsername(null));
        dispatch(setNewPassword(null));
    }, []);

    return (
        <Entrance>
            {steps[step]}
        </Entrance>
    )
}

export default ForgetPassword;
